(function () {
  var root = document.querySelector('.tv-board');
  if (!root) return;

  var configNode = root.querySelector('[data-tv-board-config]');
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var moneyFormat = config.moneyFormat || '${{amount}}';

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function toCents(price) {
    var raw = String(price);
    if (raw.indexOf('.') !== -1) return Math.round(parseFloat(raw) * 100);
    return parseInt(raw, 10);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return '0';
    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents) {
    var tokenMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = tokenMatch ? tokenMatch[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    if (!tokenMatch) return '$' + value;
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function fetchCollection(handle) {
    var products = [];
    var page = 1;

    function next() {
      return fetch('/collections/' + encodeURIComponent(handle) + '?view=tv-data&page=' + page)
        .then(function (response) {
          if (!response.ok) return [];
          return response.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          var pages = (data && data.pages) || 0;
          products = products.concat(batch);
          if (!batch.length || page >= pages || page >= 40) return products;
          page += 1;
          return next();
        })
        .catch(function () {
          return products;
        });
    }

    return next();
  }

  function categoryLabel(product) {
    return String(product.category || '').trim();
  }

  function isInStock(product) {
    return (product.variants || []).some(function (variant) {
      return variant.available;
    });
  }

  function inStockRows(product) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant.available;
    });
    if (!variants.length) return '';

    if (variants.length === 1 && (!variants[0].title || variants[0].title === 'Default Title')) {
      return (
        '<div class="tv-board__item"><span class="tv-board__name">' +
        escapeHtml(product.title) +
        '</span><span class="tv-board__price">' +
        formatMoney(toCents(variants[0].price)) +
        '</span></div>'
      );
    }

    var html =
      '<div class="tv-board__item"><span class="tv-board__name">' +
      escapeHtml(product.title) +
      '</span><span class="tv-board__price"></span></div>';

    variants.forEach(function (variant) {
      html +=
        '<div class="tv-board__item tv-board__item--variant"><span class="tv-board__name">' +
        escapeHtml(variant.title) +
        '</span><span class="tv-board__price">' +
        formatMoney(toCents(variant.price)) +
        '</span></div>';
    });

    return html;
  }

  function renderGroup(group) {
    var seen = {};
    var jobs = (group.collections || []).map(fetchCollection);

    return Promise.all(jobs).then(function (lists) {
      var products = [];
      lists.forEach(function (list) {
        list.forEach(function (product) {
          if (seen[product.id]) return;
          seen[product.id] = true;
          products.push(product);
        });
      });

      var stocked = products.filter(isInStock);
      if (!stocked.length) {
        return (
          '<section class="tv-board__group"><h2 class="tv-board__heading">' +
          escapeHtml(group.heading || '') +
          '</h2><p class="tv-board__empty">None in stock</p></section>'
        );
      }

      var buckets = {};

      stocked.forEach(function (product) {
        var label = categoryLabel(product);
        if (!label) return;
        var key = label.toLowerCase();
        if (!buckets[key]) buckets[key] = { label: label, products: [] };
        buckets[key].products.push(product);
      });

      var headings = Object.keys(buckets).sort(function (a, b) {
        return buckets[a].label.localeCompare(buckets[b].label, undefined, { sensitivity: 'base' });
      });

      function rowsFor(list) {
        list.sort(function (a, b) {
          return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
        });
        return list.map(inStockRows).filter(Boolean).join('');
      }

      var body = headings
        .map(function (key) {
          return (
            '<section class="tv-board__subgroup"><h3 class="tv-board__subheading">' +
            escapeHtml(buckets[key].label) +
            '</h3><div class="tv-board__subgroup-items">' +
            rowsFor(buckets[key].products) +
            '</div></section>'
          );
        })
        .join('');

      if (!body) {
        return (
          '<section class="tv-board__group"><h2 class="tv-board__heading">' +
          escapeHtml(group.heading || '') +
          '</h2><p class="tv-board__empty">None in stock</p></section>'
        );
      }

      return (
        '<section class="tv-board__group"><h2 class="tv-board__heading">' +
        escapeHtml(group.heading || '') +
        '</h2>' +
        body +
        '</section>'
      );
    });
  }

  function fillColumn(name, groups) {
    var column = root.querySelector('[data-column="' + name + '"] .tv-board__track');
    if (!column) return Promise.resolve();

    return Promise.all((groups || []).map(renderGroup)).then(function (html) {
      column.innerHTML = html.join('');
    });
  }

  function startScroll() {
    root.querySelectorAll('.tv-board__viewport').forEach(function (viewport) {
      var track = viewport.querySelector('.tv-board__track');
      if (!track) return;
      track.classList.remove('is-scrolling');
      track.style.animationDuration = '';
      var clone = track.querySelector('[data-clone]');
      if (clone) clone.remove();

      if (track.scrollHeight <= viewport.clientHeight + 8) return;

      var copy = track.cloneNode(true);
      copy.setAttribute('data-clone', 'true');
      copy.setAttribute('aria-hidden', 'true');
      while (copy.firstChild) track.appendChild(copy.firstChild);

      var distance = track.scrollHeight / 2;
      var seconds = Math.max(distance / 28, 20);
      track.style.animationDuration = seconds + 's';
      track.classList.add('is-scrolling');
    });
  }

  function load() {
    return Promise.all([
      fillColumn('left', config.columns && config.columns.left),
      fillColumn('right', config.columns && config.columns.right)
    ]).then(startScroll);
  }

  load().catch(function () {
    root.querySelectorAll('.tv-board__track').forEach(function (track) {
      track.innerHTML = '<p class="tv-board__status">Price list could not load.</p>';
    });
  });

  var minutes = parseInt(root.getAttribute('data-refresh-minutes'), 10);
  if (!minutes || minutes < 1) minutes = 5;
  window.setTimeout(function () {
    window.location.reload();
  }, minutes * 60 * 1000);
})();
